import React from "react";

const ReportGenerator = ({backendApiPrefix}) => {
    return (
        <div className="home">
            <h1>ReportGenerator</h1>
        </div>
    );
};

export default ReportGenerator